module.exports = __webpack_public_path__ + "static/media/eu-sklad-logo-s.f0c773aa.webp";